import { zodResolver } from '@hookform/resolvers/zod'
import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { Button } from '~/components/Button'
import { TextInput } from '~/components/TextInput'
import { useQuery } from '~/hooks/useQuery'
import { insertToast } from '~/modules/toasts/services'
import { personalTrainerLoginRoute } from '~/routes/routes'
import { api } from '~/utils/api'

import { RecoverPasswordFormType, schema } from './schema'

export const RecoverPassword: React.FC = () => {
  const queryParams = useQuery()
  const navigate = useNavigate()

  const { register, handleSubmit, formState } =
    useForm<RecoverPasswordFormType>({
      resolver: zodResolver(schema),
      defaultValues: {
        token: queryParams.get('token'),
      },
    })

  const [loading, setLoading] = useState<boolean>(false)

  const onSubmit = useCallback(async (payload: RecoverPasswordFormType) => {
    setLoading(() => true)
    await api
      .post<{ message: string }>(
        '/personal-trainers/authenticate/new-password',
        payload,
      )
      .then(({ data }) => {
        navigate(personalTrainerLoginRoute)
        insertToast({
          duration: 4,
          message: data.message,
          title: 'Sucesso',
          type: 'success',
        })
      })
      .catch((e) => {
        insertToast({
          duration: 4,
          message: e.response?.data?.message || 'Erro desconhecido',
          title: 'Erro ao alterar senha',
          type: 'error',
        })
      })
      .finally(() => {
        setLoading(() => false)
      })
  }, [])

  return (
    <form className='flex flex-col gap-4' onSubmit={handleSubmit(onSubmit)}>
      <h3 className='text-2xl mb-2'>Olá {queryParams.get('name')}</h3>

      <p>Defina uma nova senha.</p>

      <TextInput
        {...register('password')}
        label='Sua nova senha'
        type='password'
        error={formState.errors.password?.message}
      />

      <Button loading={loading}>Alterar senha</Button>
    </form>
  )
}
